import type { Project, InterfaceDefinition, Src, Dst } from "..";

export type UpdateIFDefinitionsRequest = {
  dfnSetVerNum: string;
  pjtId: string;
  isArchive?: boolean;
  ifCallerScreenType: string;
  godFlg?: string;
  ifList?: UpdateIfList[];
};
export type UpdateIfList = {
  idx: Number;
  updateDateTime?: string;
  project?: Project;
  src?: Src;
  dst?: Dst;
  notice?: Notice;
};
export type Notice = {
  evntGrpTypeCd?: string;
  srcTcktId?: string;
  srcDipByRgn?: string;
  srcCmplCntnt?: string;
  dstTcktId?: string;
  dstDipByRgn?: string;
  dstCmplCntnt?: string;
};
